import { restApi } from '../../services/api';

export const updateAgendas = async (data) => {
    return restApi.post('update-agendas', data);
  }